import { useState } from 'react';
import { Button, type ButtonProps } from './Button';
import { Modal } from './ModalOld';

type ModalButtonProps = {
	onAccept: () => void;
	onReject?: () => void;
	title: string;
	subtext?: string;
} & ButtonProps;

export function ModalButton({
	size = 'md',
	mode = 'secondary',
	onAccept,
	onReject,
	className = '',
	title = 'Are you sure?',
	subtext,
	children,
	...props
}: ModalButtonProps) {
	const [open, setOpen] = useState(false);

	return (
		<>
			<Button mode={mode} size={size} className={className} {...props} onClick={() => setOpen(true)}>
				{children}
			</Button>

			<Modal open={open} setOpen={setOpen} onAccept={onAccept} onReject={onReject} title={title} subtext={subtext} />
		</>
	);
}
